import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Product} from './product';
import * as fromStore from "../../store";
import {filter, switchMap} from "rxjs/operators";

import {Store} from "@ngrx/store";

@Injectable()
export class BackupPluginResolver implements Resolve<Product|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data['website'].id;
      const _childWebsiteId = route.parent.data['website'].isNetwork && !route.parent.data['website'].parentId && route.parent.data['website'].children && route.parent.data['website'].children.length ? route.parent.data['website'].children[0] : null;
      this._store.select(fromStore.getWebsitePluginsLoaded(_childWebsiteId || websiteId))
        .pipe(
          filter((loaded: boolean) => !!loaded),
          switchMap(() => this._store.select(fromStore.getWebsiteBackupPlugin(_childWebsiteId || websiteId)))
        )
        .subscribe((backupPlugin) => {
          if (backupPlugin) {
            resolve(backupPlugin);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
